
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/it-report/salaries",
      function () {
        return require("private-next-pages/it-report/salaries/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/it-report/salaries"])
      });
    }
  